import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Debug logging (we'll remove this later)
console.log('🔍 Environment:', process.env.NODE_ENV)
console.log('🔍 Supabase URL:', supabaseUrl)
console.log('🔍 Key starts with:', supabaseAnonKey?.substring(0, 20))

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
